import { z } from "zod";
import { geoPointSchema, qualitaConferimentoSchema, causaleAnomaliaSchema, paginationSchema, frazioneMerceologicaSchema, } from "./common.js";
export const rilevazioneSchema = z.object({
    id: z.string().uuid(),
    operatore_id: z.string().uuid(),
    turno_id: z.string().uuid().nullable(),
    contenitore_id: z.string().uuid().nullable(),
    codice_barcode_letto: z.string().max(64).nullable(),
    qualita_conferimento: qualitaConferimentoSchema,
    causale_anomalia: causaleAnomaliaSchema.nullable(),
    nota_libera: z.string().nullable(),
    geo_punto: geoPointSchema.nullable().optional(),
    accuratezza_gps_m: z.number().nullable(),
    timestamp_client: z.string().datetime(),
    timestamp_server: z.string().datetime(),
    device_id: z.string().max(64),
    foto_object_keys: z.array(z.string()),
    sync_batch_id: z.string().uuid().nullable(),
    created_at: z.string().datetime(),
});
// Payload singola rilevazione nel batch mobile
export const rilevazioneInputSchema = z
    .object({
    id: z.string().uuid(),
    turno_id: z.string().uuid().optional(),
    codice_barcode_letto: z.string().max(64).optional(),
    qualita_conferimento: qualitaConferimentoSchema,
    causale_anomalia: causaleAnomaliaSchema.optional(),
    nota_libera: z.string().max(2000).optional(),
    timestamp_client: z.string().datetime(),
    geo: geoPointSchema.optional(),
    foto_object_keys: z.array(z.string()).default([]),
})
    .refine((d) => d.qualita_conferimento === "OK" ||
    d.causale_anomalia !== undefined, {
    message: "causale_anomalia è obbligatoria per PARZIALE e NON_CONFORME",
    path: ["causale_anomalia"],
});
// Payload batch sync mobile
export const syncRilevazioniRequestSchema = z.object({
    sync_batch_id: z.string().uuid(),
    device_id: z.string().min(1).max(64),
    rilevazioni: z.array(rilevazioneInputSchema).min(1).max(100),
});
export const esitoRilevazioneSchema = z.object({
    id: z.string().uuid(),
    stato: z.enum(["INSERITA", "ALREADY_PRESENT", "RIFIUTATA"]),
    errore: z.string().optional(),
});
export const syncRilevazioniResponseSchema = z.object({
    accettate: z.number().int(),
    duplicate: z.number().int(),
    rifiutate: z.number().int(),
    esiti: z.array(esitoRilevazioneSchema),
});
// Payload batch sync traccia GPS
export const puntoGpsInputSchema = z.object({
    // geo_punto viene inviato come lat/lng e ricostruito lato server
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    accuratezza_m: z.number().optional(),
    velocita_kmh: z.number().optional(),
    timestamp_client: z.string().datetime(),
});
export const syncTracciaGpsRequestSchema = z.object({
    sync_batch_id: z.string().uuid(),
    turno_id: z.string().uuid(),
    device_id: z.string().min(1).max(64),
    punti: z.array(puntoGpsInputSchema).min(1).max(600),
});
// Filtri per consultazione back-office
export const rilevazioneFiltersSchema = paginationSchema.extend({
    turno_id: z.string().uuid().optional(),
    zona_id: z.string().uuid().optional(),
    frazione: frazioneMerceologicaSchema.optional(),
    qualita: qualitaConferimentoSchema.optional(),
    causale: causaleAnomaliaSchema.optional(),
    data_da: z.string().datetime().optional(),
    data_a: z.string().datetime().optional(),
    operatore_id: z.string().uuid().optional(),
});
//# sourceMappingURL=rilevazioni.js.map